import { motion } from "framer-motion";

export default function Gallery({ content }) {
  const items = content.gallery || [];
  return (
    <section id="gallery" className="py-24 md:py-32 bg-neutral-950 text-white" data-testid="gallery-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="text-sm uppercase tracking-widest text-orange-500 mb-4 font-medium">
              — Recent Projects
            </div>
            <h2 className="font-display font-black uppercase leading-[0.9] tracking-tighter text-4xl sm:text-5xl md:text-6xl">
              Built to last. <br />
              <span className="text-orange-500">Designed to inspire.</span>
            </h2>
          </div>
          <p className="text-neutral-400 max-w-md">
            A snapshot of the kitchens, bathrooms and full remodels we&apos;ve delivered across New York.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 md:gap-6" data-testid="gallery-grid">
          {items.map((g, i) => (
            <motion.div
              key={g.id || i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              className={`group relative overflow-hidden ${i % 5 === 0 ? "md:row-span-2 h-[400px] md:h-[620px]" : "h-[300px]"}`}
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={g.image}
                alt={g.caption || "Project"}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-neutral-950 via-transparent to-transparent opacity-70 group-hover:opacity-90 transition-opacity" />
              {g.caption && (
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <div className="font-display uppercase text-xl font-bold tracking-tight">{g.caption}</div>
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
